import { ContextKeys, DocumentLink, DocumentLinks, DocumentLinksQuery } from '@skylab-shared/business';
import { BusinessObjectBase, ModelBase, QueryBus } from '@skylab-shared/core';
import { InventoryDocumentKind } from '@skylab-shared/dataModel';
import { last } from '@skylab-shared/utils';

interface ModelPart extends ModelBase {
    id: number;
    kind: InventoryDocumentKind;
}

export abstract class InventoryLinksMixin<TModel extends ModelPart> extends BusinessObjectBase<TModel> {
    protected queryBus: QueryBus;

    public async loadLinksAsync(): Promise<void> {
        this.internalLinks = await this.localContext.getAsync(ContextKeys.documentLinks(this.model.id), () => this.queryBus.queryAsync(new DocumentLinksQuery(this.model.id)));
    }

    private internalLinks: DocumentLinks;
    public get links(): DocumentLinks {
        return this.internalLinks;
    }

    public get linksAdjustments(): DocumentLink[] | null {
        return this.links?.adjustments || null;
    }

    public get linksInventory(): DocumentLink[] | null {
        return this.links?.inventory || null;
    }

    public get linksCommercial(): DocumentLink[] | null {
        return this.links?.commercial || null;
    }

    public get linkPreviouslyAdjusted(): DocumentLink | undefined {
        return this.linksAdjustments?.find((_, index) => this.linksAdjustments?.[index + 1]?.documentId === this.model.id);
    }

    public get isDocumentAdjusted(): boolean {
        if (!this.linksAdjustments) return false;
        return last(this.linksAdjustments).documentId !== this.model.id;
    }

    public get isDocumentAssociatedWithStocktaking(): boolean {
        return !!this.linksInventory?.some(elem => elem.kind === InventoryDocumentKind.Stocktaking);
    }
}
